module.exports = __webpack_public_path__ + "static/media/mars9.4aee5d3f.jpg";